import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingProjectSequence';
import InputBar from '../InputBar';
// import BPInput from '../../BionicUI/input/BPInput';
// import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
// import { usePrivy } from '@privy-io/react-auth';
import BPTextarea from 'components/BionicUI/textarea/BPTextarea';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import BPButton from 'components/BionicUI/button/BPButton';

const Explainer = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep, setProjectInfo, projectInfo } =
    useOnboardingProjectStore();
  const [description, setDescription] = useState<string>(
    projectInfo.description
  );

  async function handleSubmit() {
    if (description.length === 0) return;
    setProjectInfo('description', description);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Provide a brief explainer or blurb about your project.',
            sound: 'projectStep/provide-brief-explainer-blurb.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar gridClass={true} onClickBackButton={() => setProgressStep(2)}>
          <BPTextarea
            value={description}
            // state="default"
            // type="text"
            hideResize={true}
            twHeight={'min-h-[150px]'}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter project explainer/blurb"
            // button={{
            //   state: 'primary',
            //   onClick: (e, inputText) => handleSubmit(inputText),
            //   title: 'Submit',
            // }}
            // validate={(text) => text.length > 3}
          />
          <BPButton
            state="primary"
            disabled={description.length < 10}
            onClick={handleSubmit}
          >
            Submit
          </BPButton>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default Explainer;
